module.exports = __webpack_public_path__ + "img/ranking.ae9d55a0.svg";